import { registerPlugin } from '@capacitor/core';
const CorsBypass = registerPlugin('CorsBypass', {
    web: () => import('./web').then(m => new m.CorsBypassWeb()),
});
export * from './definitions';
export { CorsBypass };
